import { render, staticRenderFns } from "./DatesFilter.vue?vue&type=template&id=8f4a643a&scoped=true&"
import script from "./DatesFilter.vue?vue&type=script&lang=js&"
export * from "./DatesFilter.vue?vue&type=script&lang=js&"
import style0 from "./DatesFilter.vue?vue&type=style&index=0&id=8f4a643a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4a643a",
  null
  
)

export default component.exports